import { ForgetPasswordState } from './forgetPassword.types'

const initialState: ForgetPasswordState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
